import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectVersionSummary = state => {
    return selectOwnState(state).versionSummary
}

export const selectVersionSummaryGrouped = state => {
    const versionSummary = selectVersionSummary(state)
    const versionSummaryGrouped = {}

    for (let index = 0; index < versionSummary.length; index++) {
        const version = versionSummary[index]
        const name = version.name
        if (!versionSummaryGrouped[name]) {
            versionSummaryGrouped[name] = []
        }
        versionSummaryGrouped[name].push(version)
    }
    return versionSummaryGrouped
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}



// WEBPACK FOOTER //
// ./src/modules/process/state/version-summary/selector.js